import {Component, OnDestroy, OnInit} from '@angular/core';
import {RxComponent} from '../../../../core/components/common/rx.component';
import {PlatformPriceListService} from './platform-price-list.service';
import {ModalSize, SmartModalService} from '../../../../core/services/smart-modal.service';
import {NotificationService} from '../../../../core/services/notification.service';
import {CreateNewPricingListComponent} from '../../../../shared/components/pricing/create-new-pricing-list/create-new-pricing-list.component';
import {Subject, Subscription} from 'rxjs';
import {Router} from '@angular/router';

declare var $: any;
declare var moment: any;

@Component({
  selector: 'itpx-pricing-list',
  templateUrl: './pricing-list.component.html',
  styleUrls: ['./pricing-list.component.css']
})
export class PricingListComponent extends RxComponent implements OnInit, OnDestroy {

    private priceListTableFields: any = [];
    private tabViews = {
        leapestRegions : 'leapest-region',
        sellerRegions : 'seller-region',
        buyerGroups : 'buyer-group',
        buyerSpecific : 'buyer-specific'
    };

    private currentFilter: string = this.tabViews.leapestRegions;
    private allDictionaries: any = {};
    private gridRefresh = new Subject();

    private subConfig: Subscription;
    private savePriceSub: Subscription;

    constructor(
        private smartModalService: SmartModalService,
        private priceListService: PlatformPriceListService,
        private notificationService: NotificationService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.fetchAllDictionaries();
    }

    fetchAllDictionaries() {
        this.subConfig = this.priceListService.fetchAllConfigurations().subscribe(_ => {
            this.allDictionaries = _;
            this.initiateTable();
        });
    }

    initiateTable() {
        this.priceListTableFields = [
            {
                title: 'Name',
                name: 'name',
                config: {
                    type: 'link',
                    route: '/agora/pricing-data/pricing-list/{{key}}/details',
                    key: 'id'
                }
            },
            {
                title: 'Target Group',
                name: 'targetGroup'
            },
            {
                title: 'Valid From',
                name: (item) => {
                    return this.getFormattedDate(item.validFrom);
                }
            },
            {
                title: 'Valid To',
                name: 'validTill',
                config: {
                    type: 'template',
                    template: 'validToTemplate'
                }
            }
        ];
    }

    showCreateNewPriceModal() {

        this.smartModalService.open(
            CreateNewPricingListComponent,
            {
                dictionaries: this.allDictionaries,
                pricingModel: {}
            },
            'New Price List',
            ModalSize.Custom,
        )
        .neverError()
        .subscribe(_ => {
            if (_.result) {
                this.saveNewPrice(_.result);
            }
        });
    }

    saveNewPrice(payload: any) {
        this.savePriceSub = this.priceListService.savePriceList(payload).subscribe((_) => {
            this.notificationService.success('Price list successfully saved');
            this.refreshGrid();
        })
    }

    refreshGrid() {
        this.gridRefresh.next(1);
    }

    switchTab(tabName) {
        this.currentFilter = tabName;
    }

    getListUrlForSelectedGroup() {
        return this.priceListService.getPriceListTableAPIUrl() + '?type=' + this.currentFilter;
    }

    getFormattedDate(date) {
        return date ? moment(date).format('DD-MM-YYYY') : 'N/A';
    }

    getTabClass(tabName) {
        return this.currentFilter === tabName ? 'btn-primary' : 'btn-default';
    }

    openPriceListDetails(priceList) {
        this.router.navigate(['/pricing-seller/price-lists/' + priceList.id + '/details'])
    }

    isPriceListValid(priceList) {
        if (!priceList.validFrom && !priceList.validTill) return true;
        return priceList.validFrom && priceList.validTill && (new Date(priceList.validTill) > new Date());
        // return priceList.validFrom && priceList.validTill && (new Date() > new Date(priceList.validFrom)) && (new Date(priceList.validTill) > new Date());
    }

    ngOnDestroy() {
        if (this.subConfig) this.subConfig.unsubscribe();
        if (this.savePriceSub) this.savePriceSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/pricing-data/pricing-list/pricing-list.component.ts